import React, { useState, useEffect } from 'react';
import { Breadcrumb, Card, Table, Switch, message, Form, Button } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import Modaled from './Modal';
import Modale2 from './Modal2';
import { connect } from 'react-redux';
import {
  sysRole,
  roleStatus,
  getRole,
  changePerm,
  ACTION_TYPE,
  getUserInfo,
  changeRoleType,
  useInfoStatus,
  createRole,
  createUser,
  userGetRole,
  getRoleList
} from '../../../actions/role';
import { allType } from '../../../config/jurisdiction';
import './style.css';

const FormItem = Form.Item;

const mapDispatchToProps = (dispatch: any) => ({
  sysRole: (value) => dispatch(sysRole(value)),
  roleStatus: (value: any) => dispatch(roleStatus(value)),
  getRole: (value: any) => dispatch(getRole(value)),
  changePerm: (value: any) => dispatch(changePerm(value)),
  getUserInfo: (value: any) => dispatch(getUserInfo(value)),
  changeRoleType: (value: any) => dispatch(changeRoleType(value)),
  useInfoStatus: (value: any) => dispatch(useInfoStatus(value)),
  createRole: (value: any) => dispatch(createRole(value)),
  createUser: (value: any) => dispatch(createUser(value)),
  userGetRole: (value: any) => dispatch(userGetRole(value)),
  getRoleList: (value: any) => dispatch(getRoleList()),
});

const mapStateToProps = (role: any) => (role);

interface Props extends FormComponentProps {
  sysRole: (data: any) => any;
  role: any;
  loading: boolean;
  useInfo: any;
  roleStatus: (params: any) => any;
  getRole: (params: any) => any;
  changePerm: (data: any) => any;
  getUserInfo: (data: any) => any;
  changeRoleType: (data: any) => any;
  useInfoStatus: (data: any) => any;
  createRole: (data: any) => any;
  createUser: (data: any) => any; 
  userGetRole: (data: any) => any; 
  getRoleList: () => any; 
}

const Management = (props: Props) => {

  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [recorded, setRecorded] = useState(null);
  const [record2, setRecord2] =  useState(null);
  const [title, setTitle] = useState('');
  const [title2, setTitle2] = useState('');
  const [role, setRole] = useState(props.role);
  const [useInfo, setUseInfo] = useState(props.useInfo);

  useEffect(() => {
    props.sysRole({
      page: 1,
      size: 10
    })
  }, [role])

  useEffect(() => {
    let data = {
      page: 1,
      size: 10
    }
    props.getUserInfo(data)
  }, [useInfo])

  const showModal = (record: any) => {
    props.getRoleList()
    if (record.title === '账号配置') {
      let params = {
        id: record.userId
      }
      props.userGetRole(params)
      setTitle(record.title)
      setRecorded(record)
      setVisible(true)
      return
    }
    let params = {
      id: record.id
    }
    props.getRole(params)
      .then(
        (res: any) => {
          if (res.error) {
            message.error("查询失败")
          } else {
            setTitle(record.title)
            setRecorded(record)
            setVisible(true)
          }
        }
      )

  }

  const handleOk = (e: any) => {
    e.preventDefault();
    setVisible(false)
  }

  const handleCancel = (e: any) => {
    e.preventDefault();
    setVisible(false)
  }

  const onChange = (record: any, status: any) => {
    console.log(record)
    if (record && record.title === '角色配置') {
      let params = {
        id: record.id
      }
      props.roleStatus(params)
      .then(
        (res: any) => {
          if (res.error) {
            if (status) {
              message.error('启用失败')
              props.form.resetFields([`${record.id}`]);
            } else {
              message.error('禁用失败')
              props.form.resetFields([`${record.id}`]);
            }
          } else {
            if (status) {
              message.success('启用成功')
            } else {
              message.success('禁用成功')
            }
          }
        }
      )
    } else {
      let params2 = {
        id: record.userId
      }
      props.useInfoStatus(params2)
      .then(
        (res: any) => {
          if (res.error) {
            if (status) {
              message.error('启用失败')
              props.form.resetFields([`${record.id}`]);
            } else {
              message.error('禁用失败')
              props.form.resetFields([`${record.id}`]);
            }
          } else {
            if (status) {
              message.success('启用成功')
            } else {
              message.success('禁用成功')
            }
          }
        }
      )
    }
  }

  const columns = [
    {
      title: '序号',
      dataIndex: 'key',
      key: 'key',
      className: 'column',
    },
    {
      title: '角色名称',
      dataIndex: 'roleName',
      key: 'roleName',
      className: 'column',
    },
    {
      title: '操作',
      dataIndex: '',
      key: 'operation',
      className: 'column',
      render: (record: any) => {
        return <a onClick={() => showModal(record)}>修改</a>
      }
    },
    {
      title: '状态',
      dataIndex: '',
      key: 'isDisable',
      className: 'column',
      render: (record: any) => {
        const { getFieldDecorator } = props.form;
        return (
          <div>
            <FormItem
            >
              {getFieldDecorator(`${record.id}`, {
                initialValue: record.isDisable === 1 ? true : false,
                valuePropName: 'checked',
              })
                (<Switch onChange={(e) => onChange(record, e)} className="switch_success" />)}
            </FormItem>
          </div>
        )
      }
    },
  ];

  const columns2 = [
    {
      title: '序号',
      dataIndex: 'key',
      key: 'key',
      className: 'column',
    },
    {
      title: '账号名称',
      dataIndex: 'userName',
      key: 'userName',
      className: 'column',
    }, {
      title: '操作',
      dataIndex: '',
      key: 'operation',
      className: 'column',
      render: (record2: any) => {
        return <a onClick={() => showModal(record2)}>修改</a>
      }
    },
    {
      title: '状态',
      dataIndex: '',
      key: 'isDisable',
      className: 'column',
      render: (record: any) => {
        const { getFieldDecorator } = props.form;
        return (
          <div>
            <FormItem
            >
              {getFieldDecorator(`${record.userId}`, {
                initialValue: record.isDisable === 0 ? false : true,
                valuePropName: 'checked',
              })
                (<Switch onChange={(e) => onChange(record, e)} className="switch_success" />)}
            </FormItem>
          </div>
        )
      }
    }
  ];

  const showModal2 = (record: any) => {
      setTitle2(record.title)
      setRecord2(record)
      setVisible2(true)
      props.getRoleList()
      return
  }

  // let roleData = props.role.roleData;
  const { roleData, getUserInfos, getUserRole, roleList } = props.role;
  const data = roleData.list.map((item: any, index: number) => ({
    ...item,
    key: index + 1,
    title: '角色配置'
  }))

  let userInfos = getUserInfos.list.map((item: any, index: number) => ({
    ...item,
    key: index + 1,
    title: '账号配置'
  }))

  const total1 = roleData.total;
  const total2 = getUserInfos.total;

  const onShowSizeChange1 = (page, size) => {
    const params = {
      page,
      size,
    }
    props.sysRole(params)
  }

  const onChange1 = (page, size) => {
    const params = {
      page,
      size,
    }
    props.sysRole(params)
  }

  const onShowSizeChange2 = (page, size) => {
    const params = {
      page,
      size,
    }
    props.getUserInfo(params)
  }

  const onChange2 = (page, size) => {
    const params = {
      page,
      size,
    }
    props.getUserInfo(params)
  }

  const roleListed = roleList.list.map((item: any, index: number) => ({
    ...item,
    key: index + 1,
    title: '角色配置'
  }))

  return (
    <div className="management">
      {/* <header className="management_header">
        <div className="management_header_content">
          <Breadcrumb>
            <Breadcrumb.Item>首页</Breadcrumb.Item>
            <Breadcrumb.Item>权限管理</Breadcrumb.Item>
          </Breadcrumb> */}
          <h2>权限管理</h2>
          {/* <p>管理用户角色以及角色权限</p>
        </div>
      </header> */}
      <div className="management_content">
        <div className="management_content_content">

          <Card
            type="inner"
            title="角色配置"
            // loading={props.role.loading[ACTION_TYPE.SYSROLE]}
            extra={<Button type="primary" onClick={() => showModal2({title: '添加角色'})}>添加角色</Button>}
          >
            <Table
              dataSource={data}
              columns={columns}
              loading={props.role.loading[ACTION_TYPE.SYSROLE]}
              pagination={{
                // size: "small",
                total: total1,
                showTotal: (total) => { return `共【${total}】条` },
                showSizeChanger: true,
                showQuickJumper: true,
                onShowSizeChange: onShowSizeChange1,
                onChange: onChange1
              }}
            />
          </Card>

          <Card
            type="inner"
            title="账号配置"
            // loading={props.role.loading[ACTION_TYPE.GET_USER_INFO]}
            extra={<Button type="primary" onClick={() => showModal2({title: '添加账号'})}>添加账号</Button>}
          >
            <Table
              dataSource={userInfos}
              columns={columns2}
              loading={props.role.loading[ACTION_TYPE.GET_USER_INFO]}
              pagination={{
                // size: "small",
                total: total2,
                showTotal: (total) => { return `共【${total}】条` },
                showSizeChanger: true,
                showQuickJumper: true,
                onShowSizeChange: onShowSizeChange2,
                onChange: onChange2
              }}
            />
          </Card>
          <Modaled
            title={title}
            visible={visible}
            showModal={showModal}
            handleOk={handleOk}
            handleCancel={handleCancel}
            record={recorded}
            allList={allType}
            perms={props.role.getRoleList.perms}
            changePerm={props.changePerm}
            roleList={roleListed}
            changeRoleType={props.changeRoleType}
            getUserRole={getUserRole}
          />

          <Modale2
          title={title2}
          visible={visible2}
          allList={allType}
          changeVisible={setVisible2}
          roleList={roleListed}
          createRole={props.createRole}
          sysRole={props.sysRole}
          createUser={props.createUser}
          getUserInfo={props.getUserInfo}
          />
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Management))